import React, { useState, useEffect } from 'react';
import { BLOQUES, getFechaHoy, sumarDiasHabiles, getSemanaDe, formatFechaLarga, formatFechaCorta, formatTelefono, formatRut, validarRut } from '../constants';

const COLORES_PRESET = [
  { color: '#00C8E8', bg: 'rgba(0,200,232,.18)'   },
  { color: '#00E5A0', bg: 'rgba(0,229,160,.18)'   },
  { color: '#9B51E0', bg: 'rgba(155,81,224,.18)'  },
  { color: '#FFC800', bg: 'rgba(255,200,0,.15)'   },
  { color: '#FF6B6B', bg: 'rgba(255,107,107,.18)' },
  { color: '#FF9F43', bg: 'rgba(255,159,67,.18)'  },
  { color: '#54A0FF', bg: 'rgba(84,160,255,.18)'  },
  { color: '#5F27CD', bg: 'rgba(95,39,205,.18)'   },
  { color: '#01CBC6', bg: 'rgba(1,203,198,.18)'   },
  { color: '#FF6B81', bg: 'rgba(255,107,129,.18)' },
];

export default function AgendaPT({ alumnos, entrenadores, reservas: reservasDB, onNuevaReserva, onCancelarReserva, onAgregarEntrenador, onEliminarEntrenador, onActualizarEntrenador }) {
  const [fechaActiva, setFechaActiva] = useState(getFechaHoy());
  const [vista, setVista] = useState('dia');
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEvento, setModalEvento] = useState(null);
  const [modalEnt, setModalEnt] = useState(false);
  const [formEnt, setFormEnt] = useState({ nombre: '', color: '#00C8E8', colorBg: 'rgba(0,200,232,.18)', whatsapp: '', intake: false });
  const [formAdd, setFormAdd] = useState({ entId: entrenadores[0]?.id || '', alumnoId: '', dia: getFechaHoy(), bloque: '09:00' });

  const [reservasLocales, setReservasLocales] = useState([]);

  const showToast = (msg, tipo = 'ok') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast(null), 3500);
  };
  const [modalEditEnt, setModalEditEnt] = useState(null);
  const [toast, setToast] = useState(null); // { msg, tipo: 'ok'|'error'|'warn' }
  const [formEditEnt, setFormEditEnt] = useState({ nombre: '', rut: '', whatsapp: '', color: '#00C8E8', colorBg: 'rgba(0,200,232,.18)', intake: false });

  // Si llegan entrenadores (de la API) después del primer render, o se elimina el seleccionado
  useEffect(() => {
    if (entrenadores.length && !entrenadores.some(e => e.id === formAdd.entId)) {
      setFormAdd(f => ({ ...f, entId: entrenadores[0].id }));
    }
  }, [entrenadores]); // eslint-disable-line react-hooks/exhaustive-deps

  // Normalizar reservas de API (vienen de AlumnoApp o de Supabase)
  const reservasDeAPI = (reservasDB || []).map(r => ({
    id: `api_${r.id}`,
    entId: r.profesor_id,
    alumno: r.alumno_nombre || (r.alumno ? `${r.alumno.nombre} ${r.alumno.apellido || ''}`.trim() : `Alumno ${r.alumno_id || ''}`),
    dia: r.fecha_reserva,
    bloque: r.hora_inicio?.slice(0, 5), // Postgres devuelve "HH:MM:SS", BLOQUES usa "HH:MM"
  })).filter(r => r.dia && r.bloque && r.entId);

  // Unir locales + API sin duplicados
  const todasReservas = [
    ...reservasLocales,
    ...reservasDeAPI.filter(r => !reservasLocales.some(l => l.id === r.id)),
  ];

  const getReserva = (entId, dia, bloque) =>
    todasReservas.find(r => r.entId === entId && r.dia === dia && r.bloque === bloque);

  const confirmarReserva = () => {
    const { entId, alumnoId, dia, bloque } = formAdd;
    const alumno = alumnos.find(a => a.id === alumnoId);
    const conflicto = getReserva(entId, dia, bloque);
    if (conflicto) { showToast('Ese bloque ya tiene un PT asignado para ese entrenador.', 'warn'); return; }
    const nueva = { id: Date.now(), entId, alumno: alumno ? `${alumno.nombre} ${alumno.apellido}` : 'Alumno', dia, bloque };
    setReservasLocales(prev => [...prev, nueva]);
    if (alumnoId) onNuevaReserva && onNuevaReserva({ profesor_id: entId, alumno_id: alumnoId, alumno_nombre: nueva.alumno, fecha_reserva: dia, hora_inicio: bloque, hora_fin: BLOQUES[BLOQUES.indexOf(bloque) + 1] || '22:00', tipo_sesion: 'Personalizado' });
    setModalAdd(false);
  };

  const cancelarReserva = (id) => {
    setReservasLocales(prev => prev.filter(r => r.id !== id));
    if (typeof id === 'string' && !id.startsWith('l')) onCancelarReserva && onCancelarReserva(id);
    setModalEvento(null);
  };

  const agregarEntrenador = async () => {
    if (!formEnt.nombre.trim()) return;
    const waClean = formEnt.whatsapp.replace(/[\s+\-().]/g, '');
    const creado = await onAgregarEntrenador({
      nombre: formEnt.nombre.trim(),
      telefono: waClean || '',
      color_ui: formEnt.color,
      disponible_intake: formEnt.intake,
    });
    if (creado) {
      setFormAdd(f => ({ ...f, entId: creado.id }));
      setFormEnt({ nombre: '', color: '#00C8E8', colorBg: 'rgba(0,200,232,.18)', whatsapp: '', intake: false });
    }
  };

  const eliminarEntrenador = (id) => {
    onEliminarEntrenador(id);
    setReservasLocales(prev => prev.filter(r => r.entId !== id));
  };

  const toggleIntake = (e) => {
    onActualizarEntrenador(e.id, { disponible_intake: !e.intake });
  };

  const abrirEditEnt = (e) => {
    setFormEditEnt({
      nombre: e.nombre || '',
      rut: e.rut || '',
      whatsapp: e.whatsapp ? '+' + e.whatsapp : '',
      color: e.color || '#00C8E8',
      colorBg: e.colorBg || 'rgba(0,200,232,.18)',
      intake: !!e.intake,
    });
    setModalEditEnt(e);
  };

  const guardarEditEnt = async () => {
    if (!formEditEnt.nombre.trim()) return;
    if (formEditEnt.rut.trim() && !validarRut(formEditEnt.rut)) {
      showToast('RUT inválido. Verifica el número y dígito verificador.', 'error');
      return;
    }
    const waClean = formEditEnt.whatsapp.replace(/[\s+\-().]/g, '');
    try {
      await onActualizarEntrenador(modalEditEnt.id, {
        nombre: formEditEnt.nombre.trim(),
        rut: formEditEnt.rut.trim(),
        telefono: waClean || '',
        color_ui: formEditEnt.color,
        disponible_intake: formEditEnt.intake,
      });
      setModalEditEnt(null);
      showToast('Entrenador actualizado correctamente.', 'ok');
    } catch (err) {
      showToast('Error al guardar: ' + err.message, 'error');
    }
  };

  return (
    <div className="agenda-wrap">
      {/* Header */}
      <div className="agenda-header">
        <div>
          <div className="agenda-title">Horario <span>Entrenadores</span></div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>
            Cada columna = un entrenador · Cada fila = bloque de 1 hora · Open Gym por defecto
          </div>
        </div>
        <div className="agenda-controls">
          <div className="week-nav">
            <button className="week-btn" onClick={() => setFechaActiva(f => sumarDiasHabiles(f, -1))}>‹</button>
            <span className="week-label">{formatFechaLarga(fechaActiva)}</span>
            <button className="week-btn" onClick={() => setFechaActiva(f => sumarDiasHabiles(f, 1))}>›</button>
          </div>
          <button className="btn-semana" onClick={() => setVista(v => v === 'dia' ? 'semana' : 'dia')}>
            📅 {vista === 'dia' ? 'Semana' : 'Día'}
          </button>
          <button className="btn-ent" onClick={() => setModalEnt(true)}>⚙ Entrenadores</button>
          <button className="btn-add-pt" disabled={entrenadores.length === 0} onClick={() => setModalAdd(true)}>＋ Reservar PT</button>
        </div>
      </div>

      {entrenadores.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--muted)' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🏋️</div>
          <div style={{ fontSize: 15, marginBottom: 6 }}>Aún no hay entrenadores registrados</div>
          <div style={{ fontSize: 13 }}>Agrega el primero desde <strong>⚙ Entrenadores</strong> para empezar a usar la agenda.</div>
        </div>
      )}

      {/* Vista Día */}
      {vista === 'dia' && entrenadores.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <div className="grilla-agenda" style={{ gridTemplateColumns: `70px repeat(${entrenadores.length}, 1fr)` }}>
            <div className="g-head-hora"><span style={{ fontSize: 10, color: 'var(--muted)', letterSpacing: 1, textTransform: 'uppercase' }}>Hora</span></div>
            {entrenadores.map((e, idx) => (
              <div key={e.id} className="g-head-prof" style={{ borderLeft: `3px solid ${e.color}` }}>
                <div className="prof-head-name" style={{ color: e.color }}>{e.nombre}</div>
                <div className="prof-head-sub">({String.fromCharCode(65 + idx)})</div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>
                  {todasReservas.filter(r => r.entId === e.id && r.dia === fechaActiva).length} PT este día
                </div>
              </div>
            ))}

            {BLOQUES.map((bloque, bi) => {
              const isLast = bi === BLOQUES.length - 1;
              return (
                <React.Fragment key={bloque}>
                  <div className={`g-hora ${isLast ? 'last' : ''}`}><span>{bloque}</span></div>
                  {entrenadores.map(e => {
                    const res = getReserva(e.id, fechaActiva, bloque);
                    return (
                      <div key={e.id} className={`g-cell ${isLast ? 'last' : ''}`}
                        onClick={() => res ? setModalEvento({ ...res, entrenador: e.nombre, color: e.color, colorBg: e.colorBg }) : setModalAdd(true)}>
                        {res ? (
                          <div className="bloque-pt" style={{ background: e.colorBg, borderLeftColor: e.color }}>
                            <div className="b-tipo" style={{ color: e.color }}>PERSONALIZADO</div>
                            <div className="b-alumno">👤 {res.alumno}</div>
                            <div className="b-hora">{bloque} – {BLOQUES[bi + 1] || '22:00'}</div>
                          </div>
                        ) : (
                          <div className="bloque-open">
                            <div className="b-tipo">OPEN GYM</div>
                            <div className="b-libre">Disponible para PT →</div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}

      {/* Vista Semana */}
      {vista === 'semana' && entrenadores.length > 0 && (
        <div>
          <div className="semana-tabs">
            {getSemanaDe(fechaActiva).map(fecha => (
              <button key={fecha} className={`semana-tab ${fechaActiva === fecha ? 'active' : ''}`} onClick={() => { setFechaActiva(fecha); setVista('dia'); }}>{formatFechaCorta(fecha)}</button>
            ))}
          </div>
          <div style={{ overflowX: 'auto' }}>
            <div className="grilla-agenda" style={{ gridTemplateColumns: `90px repeat(${entrenadores.length}, 1fr)` }}>
              <div className="g-head-hora"><span style={{ fontSize: 10, color: 'var(--muted)' }}>DÍA</span></div>
              {entrenadores.map(e => (
                <div key={e.id} className="g-head-prof" style={{ borderLeft: `3px solid ${e.color}` }}>
                  <div className="prof-head-name" style={{ color: e.color }}>{e.nombre}</div>
                </div>
              ))}
              {getSemanaDe(fechaActiva).map(fecha => (
                <React.Fragment key={fecha}>
                  <div className="g-hora" style={{ cursor: 'pointer' }} onClick={() => { setFechaActiva(fecha); setVista('dia'); }}>
                    <span style={{ fontSize: 12, color: fecha === fechaActiva ? 'var(--cyan)' : 'var(--muted)' }}>{formatFechaCorta(fecha)}</span>
                  </div>
                  {entrenadores.map(e => {
                    const count = todasReservas.filter(r => r.entId === e.id && r.dia === fecha).length;
                    return (
                      <div key={e.id} className="g-cell" style={{ minHeight: 48 }} onClick={() => { setFechaActiva(fecha); setVista('dia'); }}>
                        {count > 0 ? (
                          <div className="bloque-pt" style={{ background: e.colorBg, borderLeftColor: e.color }}>
                            <div className="b-tipo" style={{ color: e.color }}>{count} PT</div>
                          </div>
                        ) : (
                          <div className="bloque-open">
                            <div className="b-tipo">OPEN GYM</div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modal ver evento */}
      {modalEvento && (
        <div className="modal-overlay-agenda" onClick={() => setModalEvento(null)}>
          <div className="modal-agenda" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalEvento(null)}>✕</button>
            <div className="modal-title-agenda">Sesión PT</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              {[['Entrenador', modalEvento.entrenador], ['Alumno', modalEvento.alumno], ['Día', formatFechaLarga(modalEvento.dia)], ['Horario', `${modalEvento.bloque} – siguiente hora`]].map(([k, v]) => (
                <div key={k} className="modal-row-agenda">
                  <span className="modal-key-agenda">{k}</span>
                  <span className="modal-val-agenda">{v}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button className="btn-modal-agenda" onClick={() => setModalEvento(null)}>Cerrar</button>
              <button className="btn-modal-agenda danger" onClick={() => cancelarReserva(modalEvento.id)}>🗑 Cancelar sesión</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal añadir reserva */}
      {modalAdd && (
        <div className="modal-overlay-agenda" onClick={() => setModalAdd(false)}>
          <div className="modal-agenda" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalAdd(false)}>✕</button>
            <div className="modal-title-agenda">Reservar Entrenamiento Personal</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 4 }}>
              <div>
                <div className="form-label" style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>Entrenador</div>
                <select className="sel-agenda" value={formAdd.entId} onChange={e => setFormAdd({ ...formAdd, entId: e.target.value })}>
                  {entrenadores.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                </select>
              </div>
              <div>
                <div className="form-label" style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>Alumno</div>
                <select className="sel-agenda" value={formAdd.alumnoId} onChange={e => setFormAdd({ ...formAdd, alumnoId: e.target.value })}>
                  <option value="">Seleccionar alumno...</option>
                  {alumnos.map(a => <option key={a.id} value={a.id}>{a.nombre} {a.apellido}</option>)}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div>
                  <div className="form-label" style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>Día</div>
                  <input type="date" className="sel-agenda" value={formAdd.dia} min={getFechaHoy()}
                    onChange={e => {
                      const v = e.target.value;
                      const dow = new Date(v + 'T00:00:00').getDay();
                      if (dow === 0 || dow === 6) { showToast('Selecciona un día de lunes a viernes.', 'warn'); return; }
                      setFormAdd({ ...formAdd, dia: v });
                    }} />
                </div>
                <div>
                  <div className="form-label" style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>Bloque horario</div>
                  <select className="sel-agenda" value={formAdd.bloque} onChange={e => setFormAdd({ ...formAdd, bloque: e.target.value })}>
                    {BLOQUES.map(b => <option key={b}>{b}</option>)}
                  </select>
                </div>
              </div>
              {getReserva(formAdd.entId, formAdd.dia, formAdd.bloque) && (
                <div style={{ background: 'rgba(255,59,59,.1)', border: '1px solid var(--red)', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: 'var(--red)' }}>
                  ⚠️ Ese bloque ya tiene un PT asignado para ese entrenador.
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button className="btn-modal-agenda" onClick={() => setModalAdd(false)}>Cancelar</button>
              <button className="btn-modal-agenda primary" onClick={confirmarReserva}>Confirmar Reserva</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal gestión entrenadores */}
      {modalEnt && (
        <div className="modal-overlay-agenda" onClick={() => setModalEnt(false)}>
          <div className="modal-agenda modal-ent" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalEnt(false)}>✕</button>
            <div className="modal-title-agenda">Gestión de Entrenadores</div>

            {/* Lista actual */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Entrenadores activos</div>
              <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 10, lineHeight: 1.5 }}>
                "Alumno nuevo" = visible para alumnos que se registran solos desde la app y aún no tienen PT asignado.
                Una vez que un alumno reserva con alguien, solo le aparecerá ese entrenador en sus próximas reservas.
              </div>
              {entrenadores.map(e => (
                <div key={e.id} className="ent-row">
                  <div className="ent-color-dot" style={{ background: e.color }} />
                  <div style={{ flex: 1 }}>
                    <span className="ent-nombre">{e.nombre}</span>
                    {e.whatsapp
                      ? <div style={{ fontSize: 10, color: 'var(--green)', marginTop: 1 }}>💬 +{e.whatsapp}</div>
                      : <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 1 }}>Sin WhatsApp — usa recepción</div>
                    }
                  </div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: e.intake ? 'var(--cyan)' : 'var(--muted)', cursor: 'pointer' }}>
                    <input type="checkbox" checked={e.intake} onChange={() => toggleIntake(e)} />
                    Alumno nuevo
                  </label>
                  <span className="ent-sesiones">{todasReservas.filter(r => r.entId === e.id).length} sesiones</span>
                  <button className="btn-ent-edit" onClick={() => abrirEditEnt(e)} title="Editar">✏️</button>
                  <button className="btn-ent-del" onClick={() => eliminarEntrenador(e.id)} title="Eliminar entrenador">✕</button>
                </div>
              ))}
              {entrenadores.length === 0 && (
                <div style={{ fontSize: 13, color: 'var(--muted)', fontStyle: 'italic', padding: '8px 0' }}>Sin entrenadores registrados.</div>
              )}
            </div>

            {/* Agregar nuevo */}
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
              <div style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Agregar entrenador</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 5 }}>Nombre</div>
                  <input
                    className="sel-agenda"
                    placeholder="Nombre del entrenador"
                    value={formEnt.nombre}
                    onChange={e => setFormEnt(f => ({ ...f, nombre: e.target.value }))}
                    onKeyDown={e => e.key === 'Enter' && agregarEntrenador()}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 5 }}>
                    WhatsApp del entrenador <span style={{ color: 'rgba(90,122,144,.5)' }}>(opcional — si no, los avisos van a recepción)</span>
                  </div>
                  <input
                    className="sel-agenda"
                    placeholder="+56 9 1234 5678"
                    value={formEnt.whatsapp}
                    onChange={e => setFormEnt(f => ({ ...f, whatsapp: formatTelefono(e.target.value) }))}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8 }}>Color identificador</div>
                  <div className="color-preset-grid">
                    {COLORES_PRESET.map(c => (
                      <button
                        key={c.color}
                        className={`color-preset-btn ${formEnt.color === c.color ? 'selected' : ''}`}
                        style={{ background: c.color }}
                        onClick={() => setFormEnt(f => ({ ...f, color: c.color, colorBg: c.bg }))}
                      />
                    ))}
                  </div>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--muted)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={formEnt.intake} onChange={e => setFormEnt(f => ({ ...f, intake: e.target.checked }))} />
                  Disponible para alumnos nuevos (sin PT asignado)
                </label>
                <button className="btn-modal-agenda primary" onClick={agregarEntrenador} disabled={!formEnt.nombre.trim()}>
                  ＋ Agregar Entrenador
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast notificación */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
          background: toast.tipo === 'ok' ? 'rgba(0,229,160,.15)' : toast.tipo === 'warn' ? 'rgba(255,200,0,.15)' : 'rgba(255,59,59,.15)',
          border: '1px solid ' + (toast.tipo === 'ok' ? 'var(--green)' : toast.tipo === 'warn' ? 'var(--yellow)' : 'var(--red)'),
          color: toast.tipo === 'ok' ? 'var(--green)' : toast.tipo === 'warn' ? 'var(--yellow)' : 'var(--red)',
          borderRadius: 12, padding: '12px 24px', fontSize: 13, fontWeight: 600,
          zIndex: 9999, boxShadow: '0 4px 24px rgba(0,0,0,.4)', maxWidth: '90vw', textAlign: 'center',
          animation: 'fadeIn .2s ease'
        }}>
          {toast.tipo === 'ok' ? '✓ ' : toast.tipo === 'warn' ? '⚠️ ' : '✕ '}{toast.msg}
        </div>
      )}

      {/* Modal editar entrenador */}
      {modalEditEnt && (
        <div className="modal-overlay-agenda" onClick={() => setModalEditEnt(null)}>
          <div className="modal-agenda" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setModalEditEnt(null)}>✕</button>
            <div className="modal-title-agenda">Editar — {formEditEnt.nombre}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 4 }}>
              <div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 5 }}>Nombre</div>
                <input className="sel-agenda" value={formEditEnt.nombre}
                  onChange={e => setFormEditEnt(f => ({ ...f, nombre: e.target.value }))} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 5 }}>RUT</div>
                <input className="sel-agenda" placeholder="12.345.678-9" value={formEditEnt.rut}
                  onChange={e => setFormEditEnt(f => ({ ...f, rut: formatRut(e.target.value) }))}
                  style={{ borderColor: formEditEnt.rut && !validarRut(formEditEnt.rut) ? 'var(--red)' : undefined }} />
                {formEditEnt.rut && !validarRut(formEditEnt.rut) && (
                  <div style={{ fontSize: 11, color: 'var(--red)', marginTop: 4 }}>RUT inválido</div>
                )}
                {formEditEnt.rut && validarRut(formEditEnt.rut) && (
                  <div style={{ fontSize: 11, color: 'var(--green)', marginTop: 4 }}>✓ RUT válido</div>
                )}
              </div>
              <div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 5 }}>WhatsApp (opcional)</div>
                <input className="sel-agenda" placeholder="+56 9 1234 5678" value={formEditEnt.whatsapp}
                  onChange={e => setFormEditEnt(f => ({ ...f, whatsapp: formatTelefono(e.target.value) }))} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8 }}>Color identificador</div>
                <div className="color-preset-grid">
                  {COLORES_PRESET.map(c => (
                    <button key={c.color}
                      className={'color-preset-btn' + (formEditEnt.color === c.color ? ' selected' : '')}
                      style={{ background: c.color }}
                      onClick={() => setFormEditEnt(f => ({ ...f, color: c.color, colorBg: c.bg }))} />
                  ))}
                </div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--muted)', cursor: 'pointer' }}>
                <input type="checkbox" checked={formEditEnt.intake}
                  onChange={e => setFormEditEnt(f => ({ ...f, intake: e.target.checked }))} />
                Disponible para alumnos nuevos
              </label>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button className="btn-modal-agenda" onClick={() => setModalEditEnt(null)}>Cancelar</button>
              <button className="btn-modal-agenda primary" onClick={guardarEditEnt}>✓ Guardar cambios</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
